/**
 * A whole-node billboard, applied per frame, for the nodes that own `billboard`: Sprite3D,
 * Label3D and the AudioStreamPlayer3D gizmo. A material's `billboard_mode` is per surface
 * instead (`surfaceDrawHooks.ts`).
 */
import { useFrame } from '@react-three/fiber';
import { applyBillboard } from './nodeBillboard';
export function useBillboard(ref, mode) {
    useFrame(({ camera }) => {
        const object = ref.current;
        if (object)
            applyBillboard(object, camera, mode);
    });
}
//# sourceMappingURL=useBillboard.js.map